import request from '@/utils/request';

// 获取企微企业下拉框选项
export async function getQwCorpOptionApi() {
  const response = await request({
    url: '/admin/qw_corp_option',
    method: 'get',
  });
  return response.data;
}

// 获取企微员工下拉框选项
export async function getQwContactOptionApi(params) {
  const response = await request({
    url: '/admin/qw_contact_option',
    method: 'get',
    params: params,
  });
  return response.data;
}

// 获取企微员工列表
export async function getQwContactListApi(data) {
  const response = await request({
    url: '/admin/qw_contact_list',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 企微员工列表，聊天内容中获取用户
export async function getQwChatLogExternalApi(data) {
  const response = await request({
    url: '/admin/qw_chat_log_external',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 获取企微聊天内容
export async function getQwChatLogDetailApi(data) {
  const response = await request({
    url: '/admin/qw_chat_log_detail',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 获取企微客户列表
export async function getQwExternalListApi(data) {
  const response = await request({
    url: '/admin/qw_external_list',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 获取企微聊天搜索记录列表
export async function getQwChatLogListApi(data) {
  const response = await request({
    url: '/admin/qw_chat_log_list',
    method: 'post',
    data: data,
  });
  return response.data;
}

// 完成质检
export async function completeQwChatLogCheckApi(data) {
  const response = await request({
    url: '/admin/qw_chat_log_check',
    method: 'post',
    data: data,
  });
  return response.data;
}
